import React from "react";
// import DesktopFooter from "../../../assets/images/lemon/desktop_footer.svg";
function Footer() {
  return (
    <div className=" relative bg-lemonBaby_Footer ">
      <p className="text-center z-10 absolute bottom-0 left-0 right-0">
        Copyright © {new Date().getFullYear()}- All rights reserved by{" "}
        <span className="font-bold">FIT.bae</span>
      </p>
    </div>
  );
}

export default Footer;
